import { Link } from "react-router-dom";
import type { Movie } from "@/types/media";
import { formatViews, typeLabel } from "@/utils/media";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 91影视`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent"></div>
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-1.5 py-0.5 text-xs font-bold text-background-50">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-background-50/90 px-1.5 py-0.5 text-xs font-medium text-primary-700">
          {typeLabel(movie.type)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500/90 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <p className="truncate text-sm font-semibold text-background-50">{movie.title}</p>
          <p className="mt-0.5 truncate text-xs text-background-200">
            {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(" ")}
          </p>
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-fire-line text-accent-500"></i>
          {formatViews(movie.views)}
        </span>
        <span>{movie.updatedAt.slice(5)} 更新</span>
      </div>
    </Link>
  );
}